import { ComponentTrackingType, Icon, IconName, Text } from '@homebotapp/hb-react-component-catalog'

import { LinkButton } from '@homebotapp/hb-react-component-catalog'
import { Link as ReactRouterLink } from 'react-router-dom'

interface LinkPillProps {
  iconName: IconName
  label: string
  to: string
  tracking: ComponentTrackingType
}

export const LinkPill = ({ iconName, label, to, tracking }: LinkPillProps) => {
  return (
    <LinkButton
      color='neutral.700'
      bgColor='neutral.50'
      paddingY={4}
      paddingX={2}
      borderRadius={16}
      borderColor='neutral.200'
      borderWidth={1}
      _hover={{ bgColor: 'neutral.100', color: 'neutral.900', borderColor: 'neutral.300' }}
      as={ReactRouterLink}
      to={to}
      tracking={tracking}
    >
      <Icon name={iconName} color='neutral.700' mr={label && 2} />
      {label && (
        <Text size='xs' fontWeight='semibold' mb={0}>
          {label}
        </Text>
      )}
    </LinkButton>
  )
}
